import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Spinner } from '../../components/Spinner';
import { TextModal } from '../../components/Modal';
import { selectSpinner, selectErrors } from '../../modules/global/selectors';
import { resetErrors } from '../../modules/global/actions';
import { TopNotifications } from '../../components/TopNotifications';

interface Props {
	spinner: any;
	children: any;
	errors: any[];
}

const AppWrapper = styled.div`
	margin: 0;
	min-height: 100%;
	padding: 0;
`;

export const AppContainerImpl: React.FC<Props> = (props: Props) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>('');

	useEffect(() => {
		if (props.errors.length > 0) {
			dispatch(resetErrors());
		}
	}, [location.pathname]); // eslint-disable-line

	const getErrorDescrition = () => {
		let messages: any[] = [];
		_.forEach(props.errors, (error) => {
			if (!_.isNil(error.message)) {
				messages.push(error.message);
			}
		});
		messages = _.uniq(messages);
		return messages.length === 0 ? 'Hups, jotain meni vikaan. Kokeile myöhemmin uudestaan, tai soita asiakaspalveluumme.' : _.join(messages, ', ');
	};

	useEffect(() => {
		if (props.errors) {
			if (props.errors.length > 0) {
				setModalIsOpen(true);
				setErrorMessage(getErrorDescrition());
			} else if (modalIsOpen) {
				setModalIsOpen(false);
				setErrorMessage('');
			}
		}
	}, [props.errors]); // eslint-disable-line

	return (
		<AppWrapper>
			<Helmet titleTemplate="%s - Moi" defaultTitle="Moi" meta={[{ name: 'description', content: 'Moi Mobiili' }]} />
			<TopNotifications path={location.pathname} />
			{props.spinner.get('pendingProcessCount') > 0 && <Spinner />}
			<TextModal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} content={errorMessage} />
			{React.Children.toArray(props.children)}
		</AppWrapper>
	);
};

const mapStateToProps = (state: any) => ({
	spinner: selectSpinner(state),
	errors: selectErrors(state)
});

export default connect(mapStateToProps)(AppContainerImpl);
